// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fi-widget-settings-control-sitemap {
  display: block;
}
.fi-widget-settings-control-sitemap .fi-select-search .mat-mdc-form-field {
  width: 100%;
}
.fi-widget-settings-control-sitemap .widget-settings-checkbox-list .mat-mdc-checkbox {
  display: block;
}`, "",{"version":3,"sources":["webpack://./Source/app/widget-settings/controls/sitemap/sitemap.component.scss"],"names":[],"mappings":"AAAA;EACI,cAAA;AACJ;AAEQ;EACI,WAAA;AAAZ;AAKQ;EACI,cAAA;AAHZ","sourcesContent":[".fi-widget-settings-control-sitemap {\r\n    display: block;\r\n\r\n    .fi-select-search {\r\n        .mat-mdc-form-field {\r\n            width: 100%;\r\n        }\r\n    }\r\n\r\n    .widget-settings-checkbox-list {\r\n        .mat-mdc-checkbox {\r\n            display: block;\r\n        }\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
